
/*
* @Author: syyoon@yongtrim.com 
* @Date: 2018-07-20 19:18:45 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-11 22:22:06
*/

import { Injectable } from "@angular/core";

import { Facebook } from '@ionic-native/facebook';
import { PlatformService } from "../services/platform.service";
import { AlertService } from "../services/alert.service";




@Injectable()
export class FacebookService {

  isLoggedIn = false;

  snsId: string;
  email: string;
  name: string;
  photoUrl: string;

  constructor(
    private platformService: PlatformService,
    private alertService: AlertService,
    private fb: Facebook,
  ) {

  }

  init() {

    if (this.platformService.isWeb()) {
      return;
    }
    this.fb.getLoginStatus()
      .then(res => {
        if (res.status === 'connect') {
          this.isLoggedIn = true;
          this.getUserDetail(res.authResponse.userID);
        } else {
          this.isLoggedIn = false;
        }
      });
  }

  login(): any {
    if (this.platformService.isWeb()) {
      this.alertService.showToastMessage('웹에서는 사용하실 수 없습니다.');
      return Promise.reject({});
    }

    return this.fb.login(['public_profile', 'email'])
      .then(res => {
        if (res.status === "connected") {
          this.isLoggedIn = true;
          return this.getUserDetail(res.authResponse.userID);
        } else {
          this.isLoggedIn = false;
          return Promise.reject({})
        }
      });
  }

  
  logout(): any {
    if (!this.isLoggedIn)
      return Promise.resolve();
    return this.fb.logout()
      .then(res => {
        this.isLoggedIn = false;
        return Promise.resolve();
      })
  }


  private getUserDetail(userid) {
    return this.fb.api("/" + userid + "/?fields=id,email,name,picture,gender", ["public_profile"])
      .then(res => {
        this.snsId = res.id;
        this.email = res.email;
        this.name = res.name;
        this.photoUrl = res.picture && res.picture.data ? res.picture.data.url : '';
        return Promise.resolve({
          snsId: this.snsId,
          email: this.email,
          name: this.name,
          photoUrl: this.photoUrl,
        });
      })
  }
}



// WEBPACK FOOTER //
// ./src/services-sns/facebook.service.ts